// libraries
import { useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
// hooks & contexts
import { useDispatch } from "react-redux";
// store
import { initializeSettings } from "./store/settings/settings";
import { initializeMapLayers  } from "./store/map-layers/map-layers";

export const useInitializeUserSettings = () => {

    const dispatch = useDispatch();

    useEffect(
        () => {
            dispatch(initializeSettings() as any);
        }, []
    )
};

export const useInitializeMapLayers = () => {

    const dispatch = useDispatch();

    useEffect(
        () => {
            dispatch(initializeMapLayers() as any);
        }, []
    )
};

export const useInitializeUserId = () => {

    useEffect(
        () => {
            const userId = localStorage.getItem("userId");

            if (!userId) {
                localStorage.setItem("userId", generateBase64Guid());
            }
        }, []
    )
};

export const generateBase64Guid = (): string => {
    const guid = uuidv4();
    const base64 = Buffer.from(guid, 'utf-8').toString('base64');
    return base64;
  };